import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {StateConfigService} from "../../../services/state/state-config.service";
import {ChatService} from "../service/chat.service";
import {faFile, faFolderOpen} from "@fortawesome/pro-solid-svg-icons";
import {PopoutContentService} from "../../../services/popout/popout.service";
import {ProjectFileControllerService} from "../../../api";

import {FaIconComponent} from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-all-files-view',
    templateUrl: './all-files-view.component.html',
    styleUrls: ['./all-files-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent]
})
export class AllFilesViewComponent {
  protected chatService = inject(ChatService);

  /** Die Dateiliste gehört zur Chat-Seite, also zum klassischen Chat. */
  protected get session() {
    return this.chatService.session('classic');
  }
  private popOutService = inject(PopoutContentService);
  private stateConfigService = inject(StateConfigService);
  private fileControllerService = inject(ProjectFileControllerService);


  get project() {
    return this.stateConfigService.getProject()
  }

  openSource(source: {dataId: string, fileName: string }) {
    const id = source.dataId
    const url = "projects/" + this.project?.id + "/files/" + id
    this.popOutService.open(url, source.fileName, true)
  }

  openFolder(source: {dataId: string, fileName: string}){
    this.fileControllerService.getFile(this.stateConfigService.getProjectId(), source.dataId!).subscribe(file => {
      const url = "projects/"+this.project?.id+"/files";
      this.popOutService.open(url, source.fileName, true)
    })
  }

  protected readonly faFile = faFile;
  protected readonly faFolderOpen = faFolderOpen;
}
